if (!customElements.get('newsletter-modal')) {
  customElements.define(
    'newsletter-modal',
    class NewsletterModal extends ModalElement {
      constructor() {
        super();
    
        // Prevent popup on Shopify robot challenge page
        if (window.location.pathname === '/challenge' || !theme.cookiesEnabled) {
          return;
        }
    
        if (!theme.config.isTouch || Shopify.designMode) {
          this.init();
        }
        else {
          new theme.initWhenVisible(theme.utils.throttle(this.init.bind(this)));
        }
      }
    
      get shouldLock() {
        return true;
      }
    
      get testMode() {
        return this.getAttribute('data-test-mode') === 'true';
      }
    
      get delay() {
        return this.hasAttribute('data-delay') ? parseInt(this.getAttribute('data-delay')) : 5;
      }
    
      get expiry() {
        return this.hasAttribute('data-expiry') ? parseInt(this.getAttribute('data-expiry')) : 30;
      }
    
      get cookieName() {
        return 'concept:newsletter-popup';
      }
    
      get submited() {
        return this.querySelector('.alert') !== null;
      }

      // feat：专门检测是否订阅成功
      get subscribedSuccessfully() {
        return this.querySelector('.alert--success') !== null;
      }
    
      init() {
        if (this.initialized) return;
        this.initialized = true;
        
        // Open modal if errors or success message exist
        if (this.submited) {
          if (this.subscribedSuccessfully) {
            this.load(0.1);
            // 等弹窗动画开始后再切换内容
            setTimeout(() => this.showSuccessState(), 300);
          } else {
            this.load(1);
          }
          return;
        }
    
        if (this.testMode || !this.getCookie(this.cookieName)) {
          this.load(this.delay);
        }
      }

      // ─── 成功态 ────────────────────────────────────────────────
      showSuccessState() {
        const successEl = this.querySelector('[id^="NewsletterSuccessState-"]');
        if (!successEl) return;

        // ✅ 加 class，CSS 自动隐藏 rich-text
        this.classList.add('is-success');

        successEl.removeAttribute('hidden');
        this.initCopyButton(successEl);
      }

      showFormError(form, message) {
        // 复用或创建错误提示元素
        let errorEl = form.querySelector('.newsletter-ajax-error');
        if (!errorEl) {
          errorEl = document.createElement('p');
          errorEl.className = 'newsletter-ajax-error';
          errorEl.setAttribute('role', 'alert');
          errorEl.style.cssText = 'color:red; margin-top:8px; font-size:0.875rem;';
          form.appendChild(errorEl);
        }
        errorEl.textContent = message;
      }

      // ─── feat：Copy Code 逻辑 ───────────────────────────────
      initCopyButton(container) {
        const copyBtn = container.querySelector('.newsletter-success__copy-btn');
        if (!copyBtn || copyBtn.dataset.copyInited) return;

        copyBtn.dataset.copyInited = 'true';

        copyBtn.addEventListener('click', () => {
          const targetId = copyBtn.dataset.copyTarget;
          const codeEl = document.getElementById(targetId);
          if (!codeEl) return;

          const code = codeEl.textContent.trim();
          const copyLabel = copyBtn.dataset.copyLabel || 'Copy Code';
          const copiedLabel = copyBtn.dataset.copiedLabel || '✓ Copied!';
          const btnText = copyBtn.querySelector('.btn-text') || copyBtn;

          const writeText = navigator.clipboard
            ? navigator.clipboard.writeText(code)
            : Promise.resolve(this.legacyCopy(code));

          writeText
            .then(() => {
              btnText.textContent = copiedLabel;
              copyBtn.setAttribute('disabled', '');
              copyBtn.classList.add('is-copied');

              // 3 秒后复原
              setTimeout(() => {
                btnText.textContent = copyLabel;
                copyBtn.removeAttribute('disabled');
                copyBtn.classList.remove('is-copied');
              }, 3000);
            })
            .catch(() => {
              console.warn('[NewsletterModal] Clipboard write failed.');
            });
        });
      }

      legacyCopy(text) {
        const ta = document.createElement('textarea');
        ta.value = text;
        ta.style.cssText = 'position:fixed;top:-9999px;left:-9999px;opacity:0;';
        document.body.appendChild(ta);
        ta.focus();
        ta.select();
        try {
          document.execCommand('copy');
        } finally {
          document.body.removeChild(ta);
        }
      }
    
      load(delay) {
        if (Shopify.designMode) return;
    
        setTimeout(() => this.show(), delay * 1000);
      }
    
      afterShow() {
        super.afterShow();
        this.classList.add('show-image');
      }
    
      afterHide() {
        super.afterHide();
        this.classList.remove('show-image');
    
        // Remove a cookie in case it was set in test mode
        if (this.testMode) {
          this.removeCookie(this.cookieName);
          return;
        }
    
        this.setCookie(this.cookieName, this.expiry);
      }
    
      getCookie(name) {
        const match = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
        return match ? match[2] : null;
      }
    
      setCookie(name, expiry) {
        document.cookie = `${name}=true; max-age=${(expiry * 24 * 60 * 60)}; path=/`;
      }
    
      removeCookie(name) {
        document.cookie = `${name}=; max-age=0`;
      }
    }
  );
}
